class pgweb.TableSortBehaviour

	# Sorting of tables by clicking on column titles.
	
	# Requirements:
	# - The table must have an id of the format "{prefix}-table".
	# - The table header (<thead>) must have an id of the format "{prefix}-thead".
	# - Each column header (<th>) must have an id of the format "col-{columnName}".
	# - Each sortable column header must contain a link (<a>).
	# - The link (<a>) in a sortable column header must have the class "col-sortable".
	# - Each cell (<td>) in a sortable column must have a class of the format "{prefix}-td-{columnName}".
	# - Inside each cell (<td>) in a sortable column, there must be an element with the
	#   class "table-value" that contains the value to sort by.

	prefix = null
	defaultColumnName = null
	defaultDirection = null

	@init: (_prefix, _defaultColumnName, _defaultDirection) ->
		prefix = _prefix
		defaultColumnName = _defaultColumnName
		defaultDirection = _defaultDirection
		$(document).off 'click', '.col-sortable'
		$(document).on 'click', '.col-sortable', (event) =>
			onColHeaderClick $(event.target)
		makeHeaderSticky()
	
	makeHeaderSticky = =>
		# Header sticky to the top when scrolling down.
		scrollState = 1
		# Here, addEventListener must be used because the Capture Event flag is needed.
		document.addEventListener 'scroll', (e) =>
			tableId = prefix+'-table'
			if $('#'+tableId).length == 0 then return
			theadId = prefix+'-thead'
			limit = $('#'+tableId).offset().top
			if scrollState == 0
				if window.scrollY >= limit
					scrollState = 1
					# Make a copy of the header and change the id of the copy.
					$('#'+theadId).clone().attr('id', theadId+'-duplicate').appendTo '#'+tableId
					# Detech the  normal header.
					$('#'+prefix+'-thead').addClass 'list-header-detached'
					# Remove IDs of the duplicate.
					trdups = $('#'+theadId+'-duplicate tr')
					for tr in trdups
						$(tr).attr 'id', null
					# Copy widths.
					ths = $('#'+theadId+' th')
					thdups = $('#'+theadId+'-duplicate th')
					for i in [0..ths.length-1]
						$(ths[i]).width $(thdups[i]).width()
			if scrollState == 1
				if window.scrollY < limit
					scrollState = 0
					$('#'+theadId).removeClass 'list-header-detached'
					$('#'+theadId+'-duplicate').remove()
		, true # Capture event

	@refreshSorting: ->
		url = new URL window.location.href
		sortBy = url.searchParams.get 'sortBy'
		reverse = url.searchParams.get 'reverse'
		if !sortBy
			sortBy = defaultColumnName
			if defaultDirection == 1
				reverse = if reverse then 0 else 1
		colHeader = $('#col-'+sortBy+' a')
		sortAndReplaceRows colHeader, sortBy, reverse

	onColHeaderClick = (clickedHeader) =>
		clickedColumnName = (clickedHeader.parent().attr('id').split '-')[1]
		columnName = clickedColumnName
		url = new URL window.location.href
		lastSortBy = url.searchParams.get 'sortBy'
		reverse = parseInt ((url.searchParams.get 'reverse') ? 0)

		# Determine if sort order is:
		# 1) ascending for the selected column
		# 2) descending for the selected column
		# 3) ascending for the default column
		# And handle the sort direction arrow.
		
		# When switching column, remove the symbol from the last one.
		if lastSortBy != columnName
			$('#col-'+lastSortBy+' a i').remove()
		
		icon = $('#col-'+columnName+' a i').eq(0)
		if icon.length == 0 # There is no icon. Switch to ascending or descending.
			if reverse
				$('#col-'+columnName+' a').append '<i class="fa fa-arrow-up"></i>'
				url.searchParams.set 'reverse', 1
				url.searchParams.set 'sortBy', columnName
				reverse = 1
			else
				$('#col-'+columnName+' a').append '<i class="fa fa-arrow-down"></i>'
				url.searchParams.delete 'reverse'
				url.searchParams.set 'sortBy', columnName
				reverse = 0
		else
			if icon.hasClass 'fa-arrow-down' # Ascending, switch to descending
				$('#col-'+columnName+' a i').removeClass 'fa-arrow-down'
				$('#col-'+columnName+' a i').addClass 'fa-arrow-up'
				url.searchParams.set 'reverse', 1
				url.searchParams.set 'sortBy', columnName
				reverse = 1
			else if icon.hasClass 'fa-arrow-up' # Descending, switch to default
				$('#col-'+columnName+' a i').remove()
				columnName = defaultColumnName
				url.searchParams.delete 'sortBy'
				url.searchParams.delete 'reverse'
				reverse = 0

		icon = $('#col-'+columnName+' a i').eq(0)
		if columnName == defaultColumnName and defaultDirection == -1
			if icon.hasClass 'fa-arrow-down'
				reverse = 1
			else if icon.hasClass 'fa-arrow-up'
				reverse = 0

		window.setTimeout ->
			sortAndReplaceRows clickedHeader, columnName, reverse
		, 0
		
		# Replace the url
		window.history.replaceState null, null, url
		
		# Inhibit the clicked link.
		false

	sortAndReplaceRows = (clickedHeader, columnName, reverse) ->
		table = clickedHeader.closest 'table'

		direction = if columnName == defaultColumnName then defaultDirection else 1

		# Do the sorting.
		trsSorted = sortRows table, columnName, direction

		# Handle reverse sorting.
		allValues = (findRowValue $(item), columnName for item in trsSorted)
		allEqual = allValues.every (item) -> item == allValues[0]
		if reverse and not allEqual
			trsSorted.reverse()

		# Replace all the rows.
		$(table).find('tbody').html trsSorted

	findRowValue = (row, columnName) ->
		row.find('.'+prefix+'-td-'+columnName+' .table-value').text().trim()

	sortRows = (table, columnName, direction) ->
		trs = table.find('tbody tr').toArray()
		trs.sort (aRow, bRow) ->
			aValue = findRowValue $(aRow), columnName
			bValue = findRowValue $(bRow), columnName
			if aValue.isNumber() and bValue.isNumber()
				aValue = parseFloat commaToDot aValue
				bValue = parseFloat commaToDot bValue
			else
				aValue = aValue.toLowerCase()
				bValue = bValue.toLowerCase()
			if aValue < bValue
				-direction
			else if aValue > bValue
				direction
			else 0
